module.exports = __webpack_public_path__ + "img/Bodice-Back-Jc-Kg-Lc.491a51a6.png";